import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container } from "reactstrap";
import { ToastContainer } from "react-toastify";
import "./ReturnDetail.scss";
import UserIcon from "../../../../assets/images/userIcon.png";
import viewIcon from "../../../../assets/images/viewProduct.png";
import productImg from "../../../../assets/images/ayeza-khan-img.png";
import playCircle from "../../../../assets/images/play-circle.png";
import ayezaKhan from "../../../../assets/images/ayeza-khan-img.png";
import profileIcon from "../../../../assets/images/buypass-User_profile.png";
import addIcon from "../../../../assets/images/add-icon.png";
import sendIcon from "../../../../assets/images/send-icon.png";
import msgOpen from "../../../../assets/images/msg-modal-open.png";
import { useEffect, useRef, useState } from "react";
import Image from "../../../../assets/images/image 323.png";

const ReturnOrderDetail = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const chatRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (chatRef.current && !chatRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // useEffect(() => {
  //   console.log(orderInfo);
  //   dispatch(fetchReturnOrderDetail(orderId));
  // }, [orderId]);

  // const openViewer = (videoUrl: string) => {
  //   setCurrentImage(videoUrl);
  //   setViewerOpen(true);
  // };
  // const closeViewer = () => {
  //   setViewerOpen(false);
  // };

  // const formatStatus = (status: any) => {
  //   if (!status) return "Unknown Status";

  //   return status
  //     .replace(/([A-Z])/g, " $1")
  //     .replace(/^./, (str: any) => str.toUpperCase());
  // };

  // const formattedStatus = formatStatus(orderInfo?.status);

  // useEffect(() => {
  //   if (trackOrderModal) {
  //     dispatch(getReturnActivies({ orderId: orderInfo?.orderId }));
  //   }
  // }, [trackOrderModal]);

  return (
    <div className="page-content ordersMainPage">
      {/* <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Refund Orders"
          pageTitle="Rider Order"
          pageTitleRoute="/return-order-detail"
        />
        <Card className="Detail-Content_Main">
          <div className="information_main">
            <div className="user-main">
              <div className="user">
                <input type="checkbox" />
                <img src={UserIcon} alt="" />
                <p>M Maria</p>
              </div>
              <div className="order">
                <div className="order-one" style={{ width: "240px" }}>
                  <h1>
                    Order ID:{" "}
                    <span>
                      #<u>102574389573434</u>
                    </span>{" "}
                    <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"></i>{" "}
                    <img src={viewIcon} alt="viewIcon" /> QTY:{" "}
                    <span className="text-black fw-bold">6</span>{" "}
                  </h1>
                  <h1>
                    Return Order ID:{" "}
                    <span className="text-black">#102574389573434</span>{" "}
                    <i className="bx bx-copy fs-6 fw-light cursor-pointer copy-icon"></i>{" "}
                  </h1>
                </div>
                <div className="order-one" style={{ width: "217px" }}>
                  <h1>
                    Create Time:
                    <span className="text-black">
                      01 Feb 2025{" "}
                      <span className="text-black fw-bold">10:00AM</span>{" "}
                    </span>{" "}
                  </h1>
                  <h1>
                    Return Order Time:
                    <span className="text-black">
                      01 Feb 2025{" "}
                      <span className="text-black fw-bold">10:00AM</span>
                    </span>{" "}
                  </h1>
                </div>
                <div
                  className="order-one gap-change"
                  style={{ width: "121px" }}
                >
                  <div className="dot-main">
                    <div className="dot"></div>
                    <a>QC In Progress</a>
                  </div>
                  <p>Q-Commerce</p>
                  <h6>3 Hours Delivery</h6>
                </div>
                <div className="order-one" style={{ width: "311px" }}>
                  <div className="d-flex">
                    <button className="btn-1">Logistic Status</button>
                    <button className="btn btn-secondary">Approve</button>
                    <button className="btn-3">Reject</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Product_Information">
            <div className="product-one">
              <div>
                <img src={Image} alt="" />
              </div>
              <div>
                <p>
                  Portable Toothbrush Kit Case Toothpaste Cup Holder Protect
                  Portable Toothbrush Kit Case ahsbdahsbd
                </p>
                <h3>
                  Seller SKU: <span> TS1247845748574958495345</span>{" "}
                  <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"></i>
                </h3>
                <h3>
                  Return Item ID: <span> TS1247845748574958495345</span>{" "}
                  <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"></i>
                </h3>
                <h3>
                  Order Item ID: <span> TS1247845748574958495345</span>{" "}
                  <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"></i>
                </h3>
              </div>
            </div>
            <div className="product-two">
              <h5>
                Paid Price + Shipping Fee:{" "}
                <span className="text-black fw-bold ms-1"> Rs. 99</span>
              </h5>
              <h5>
                Refund Amount:{" "}
                <span className="text-black fw-bold ms-1"> Rs. 99</span>
              </h5>
              <h5>
                Return Reason:
                <span className="text-black fw-bold ms-1">Item Missing</span>
              </h5>
              <p>Communication History</p>
            </div>
            <div className="product-three">
              <h3>
                Order Item ID: <span> TS1247845748574958495345</span>{" "}
                <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"></i>
              </h3>
              <h3>
                Logistic Status: <span> Pending QC </span>{" "}
              </h3>
            </div>
          </div>
          <div className="video-main">
            <div className="video_Uploader">
              <div className="video-box">
                <h1>Seller Proof video</h1>
                <div className="box">
                  <img src={playCircle} alt="" />
                </div>
                <div className="gap-box">
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                </div>
              </div>
              <button>Chat With Seller</button>
            </div>
            <div className="video_Uploader">
              <div className="video-box">
                <h1>Buyes Proof video</h1>
                <div className="box">
                  <img src={playCircle} alt="" />
                </div>
                <div className="gap-box">
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                  <div className="small-box">
                    <img src={playCircle} alt="" />
                  </div>
                </div>
              </div>
              <button>Chat With Customer</button>
            </div>
          </div>
          <div className="position">
            <img
              src={msgOpen}
              onClick={() => setIsOpen(true)}
              alt="Open Chat"
              className="cursor-pointer"
            />
            <a>99</a>
          </div>

          {isOpen && (
            <div className="SellerBuyersModal" ref={chatRef}>
              <div className="modal_Body">
                <div className="absolute top-0 left-0 bg-white border shadow-lg  w-80">
                  <div className="product-main">
                    <div>
                      {" "}
                      <img src={ayezaKhan} alt="" />{" "}
                    </div>
                    <div>
                      <p>
                        Portable Toothbrush Kit Case Toothpaste Toothpast
                        eToothpast eToothpas teToothpas teToothpaste
                      </p>
                      <h1>
                        {" "}
                        Order Item ID:<span>TS12478457</span>{" "}
                        <i className="bx bx-copy fs-6 fw-light cursor-pointer copy-icon"></i>{" "}
                      </h1>
                    </div>
                  </div>
                  <div className="chat-main">
                    <h1 className="text-black">
                      Buyers<span>Seller</span>
                    </h1>
                    <div className="admin">
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                      <div>
                        <p>Admin</p>
                        <a>Could you please share your order ID?</a>
                      </div>
                    </div>
                    <div className="buyers">
                      <div>
                        <p>Buyer</p>
                        <a>I received the wrong item.</a>
                      </div>
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                    </div>
                    <div className="admin">
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                      <div>
                        <p>Admin</p>
                        <a>Could you please share your order ID?</a>
                      </div>
                    </div>
                    <div className="buyers">
                      <div>
                        <p>Buyer</p>
                        <a>I received the wrong item.</a>
                      </div>
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                    </div>
                    <div className="admin">
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                      <div>
                        <p>Admin</p>
                        <a>Could you please share your order ID?</a>
                      </div>
                    </div>
                    <div className="buyers">
                      <div>
                        <p>Buyer</p>
                        <a>I received the wrong item.</a>
                      </div>
                      <div className="d-flex">
                        <img src={profileIcon} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="input-main">
                    <img src={addIcon} alt="" />
                    <input type="text" placeholder="Aa" />
                    <img src={sendIcon} alt="" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Card>
      </Container> */}
    </div>
  );
};

export default ReturnOrderDetail;
